import * as S from './styles';

interface LoadingProps {
  color?: string;
}

const Loading = ({ color }: LoadingProps) => {
  return (
    <S.Ripple color={color}>
      <div />
      <div />
    </S.Ripple>
  );
};

Loading.defaultProps = {
  color: '#fff',
};

export default Loading;
